export default "__VITE_ASSET__CztrDdi0__"